module.exports = __webpack_public_path__ + "img/t5-c4.19556b24.png";